export function parallax() {
    let $window = $(window);
    let $parallax = $(".has-parallax");

    $window.on("load scroll", function () {
        let scrollTop = $window.scrollTop();
        if ($window.innerWidth() >= 1200) {
            $parallax.each(function () {
                let $this = $(this);
                let itemTop = $this.offset().top;
                let speed = $this.data("speed") || 2;

                $this.css({'transform': 'translateY(' + (scrollTop - itemTop) / speed + 'px' + ')'});
            });
        } else {
            $parallax.removeAttr("style")
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js